import { PortalModule } from '@ciimar/shared';

/**
 * Human labels (pt-PT) and icon names for the portal modules. Shared by the
 * Permissões admin UI and the permission-driven navigation shell so both name
 * and draw the modules the same way.
 */
/**
 * Stable i18n key suffix per module (e.g. `modules.colaboradores`,
 * `moduleHints.colaboradores`). Language-independent, so navigation state keyed
 * on it survives a language switch — unlike the display label.
 */
export const MODULE_KEY: Record<PortalModule, string> = {
  [PortalModule.Colaboradores]: 'colaboradores',
  [PortalModule.Onboarding]: 'onboarding',
  [PortalModule.Rh]: 'rh',
  [PortalModule.SafeLab]: 'safelab',
  [PortalModule.Permissoes]: 'permissoes',
  [PortalModule.ActiveDirectory]: 'activeDirectory',
  [PortalModule.Definicoes]: 'definicoes',
  [PortalModule.Dashboard]: 'dashboard',
  [PortalModule.Viaturas]: 'viaturas',
  [PortalModule.Equipa]: 'equipa',
  [PortalModule.Artigos]: 'artigos',
  [PortalModule.Presencas]: 'presencas',
};

export const MODULE_LABELS: Record<PortalModule, string> = {
  [PortalModule.Colaboradores]: 'Colaboradores',
  [PortalModule.Onboarding]: 'Onboarding',
  [PortalModule.Rh]: 'RH',
  [PortalModule.SafeLab]: 'SafeLab',
  [PortalModule.Permissoes]: 'Permissões',
  [PortalModule.ActiveDirectory]: 'Active Directory',
  [PortalModule.Definicoes]: 'Definições',
  [PortalModule.Dashboard]: 'Dashboard',
  [PortalModule.Viaturas]: 'Viaturas',
  [PortalModule.Equipa]: 'Equipas de Investigação',
  [PortalModule.Artigos]: 'Produção Científica',
  [PortalModule.Presencas]: 'Registo Presenças',
};

/** Icon name (see `primitives.tsx` ICONS) for each module. */
export const MODULE_ICONS: Record<PortalModule, string> = {
  [PortalModule.Colaboradores]: 'users',
  [PortalModule.Onboarding]: 'spark',
  [PortalModule.Rh]: 'book',
  [PortalModule.SafeLab]: 'waves',
  [PortalModule.Permissoes]: 'key',
  [PortalModule.ActiveDirectory]: 'grid',
  [PortalModule.Definicoes]: 'cog',
  [PortalModule.Dashboard]: 'home',
  [PortalModule.Viaturas]: 'car',
  [PortalModule.Equipa]: 'users',
  [PortalModule.Artigos]: 'book',
  [PortalModule.Presencas]: 'cal',
};

/** Short pt-PT description of what each module is for (admin hints). */
export const MODULE_HINTS: Record<PortalModule, string> = {
  [PortalModule.Colaboradores]: 'Gestão da ficha dos colaboradores.',
  [PortalModule.Onboarding]: 'Convites e revisão de novos colaboradores.',
  [PortalModule.Rh]: 'Recursos Humanos.',
  [PortalModule.SafeLab]: 'Segurança e saúde no laboratório.',
  [PortalModule.Permissoes]: 'Atribuição de acessos a módulos.',
  [PortalModule.ActiveDirectory]: 'Aprovisionamento de contas AD.',
  [PortalModule.Definicoes]: 'Configuração do portal (campos, integrações).',
  [PortalModule.Dashboard]: 'Visão geral do portal.',
  [PortalModule.Viaturas]: 'Viaturas e lugares de estacionamento.',
  [PortalModule.Equipa]: 'Equipas de Investigação e Linhas Temáticas (SISTRADE).',
  [PortalModule.Artigos]: 'Produção científica (artigos) via Scopus/Elsevier.',
  [PortalModule.Presencas]: 'Registos diários de assiduidade (API ou BD interna).',
};
